<div class="cart-preview-item-inactive d-flex justify-content-between">
  <div>
    <span i18n="@@CartPreviewItemInactiveProductNumber">Item #</span>
    <span> {{ productIdentifier?.productNumber }}</span>
  </div>

  <app-cart-validation-result-cart-item [cartItemValidationError]="shoppingCartItemValidationErrorProductIsInactive">
  </app-cart-validation-result-cart-item>

  <app-product-delete-icon [toolTipHtmlContent]="deleteIconTooltipHtmlContent" (deleteSubmit)="deleteItem()"
    class="d-inline-block mx-2">
  </app-product-delete-icon>

</div>
